import styles from "./Graph.module.css";
import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import Header from "../../components/Header/Header";
import { useSearchParams } from "react-router-dom";
import {
  getClientJobsStatistics,
  getClientsPieData,
  getJobsStatusPieData,
} from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import {
  optionChart,
  options,
  optionsPieChart,
  optionsStatusPieChart,
} from "./optionsChart";

export function Graph() {
  const { state } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [date, setDate] = useState(null);
  const [week, setWeek] = useState<any>(searchParams.get("week") || 1);
  const [year, setYear] = useState<any>(searchParams.get("year") || 2024);
  const [clientPieData, setClientPieData] = useState([]);
  const [statusPieData, setStatusPieData] = useState([]);
  const [clientJobsStatistics, setClientJobsStatistics] = useState<any>([]);

  const getClientsPieDatas = async () => {
    try {
      const response = await getClientsPieData(state.user?.token, week, year);
      setClientPieData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getJobsStatusPieDatas = async () => {
    try {
      const response = await getJobsStatusPieData(
        state.user?.token,
        week,
        year
      );
      setStatusPieData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getClientJobStatistics = async () => {
    try {
      const response = await getClientJobsStatistics(
        state.user?.token,
        week,
        year
      );
      setClientJobsStatistics(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const pieData: any = clientPieData.map(({ name, value }) => [name, value]);
  pieData.unshift(["Clients", "Shifts"]);

  const days = ["Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri"];

  const header = [
    "Days",
    ...clientJobsStatistics.map((item: any) => item.name),
  ];

  const rows = days.map((day, dayIndex) => {
    const row = [day];
    clientJobsStatistics.forEach((item: any) => {
      row.push(item.value[dayIndex]);
    });
    return row;
  });

  const data = [header, ...rows];

  const pieSatusData: any = statusPieData.map(({ name, value }) => [
    name,
    value,
  ]);
  pieSatusData.unshift(["Status", ""]);

  useEffect(() => {
    getClientsPieDatas();
    getJobsStatusPieDatas();
    getClientJobStatistics();
    setSearchParams({ year, week }, { replace: true });
  }, [date]);

  return (
    <>
      <Header
        setDate={setDate}
        week={week}
        setWeek={setWeek}
        year={year}
        setYear={setYear}
      />
      <div style={{ marginTop: "80px" }}>
        <div className={styles.charts}>
          <div className={styles.pieChart}>
            <Chart
              chartType="PieChart"
              width="100%"
              height="550px"
              data={pieData}
              options={optionsPieChart}
            />
          </div>
          <div className={styles.lineChart}>
            <Chart
              chartType="LineChart"
              width="100%"
              height="550px"
              data={data}
              options={options}
            />
          </div>
        </div>
        <div className={styles.charts}>
          <div className={styles.columnChart}>
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="550px"
              data={data}
              options={optionChart}
            />
          </div>
          <div className={styles.pieChartStatus}>
            <Chart
              chartType="PieChart"
              width="100%"
              height="550px"
              data={pieSatusData}
              options={optionsStatusPieChart}
            />
          </div>
        </div>
      </div>
    </>
  );
}
